import AppRoutes from '../routers/routes';

import './App.css';

function App() {
  return <AppRoutes/>;
}

export default App;
